import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLearnedWordsDetail } from '../utils/storage';
import BackButton from '../components/BackButton';
import Icon from '../components/Icon';
import './styles/LearnedWordsScreen.css';

const LearnedWordsScreen = () => {
  const { t, i18n } = useTranslation();
  const getAns = (word) => (i18n.language !== 'en' && word[i18n.language]) || word.answer;
  const details = getLearnedWordsDetail();

  const grouped = {};
  details.forEach(word => {
    const section = word.section || 'Unknown';
    if (!grouped[section]) grouped[section] = [];
    grouped[section].push(word);
  });

  const totalCount = details.length;

  return (
    <div className="container">
      <BackButton label="Back" />
      <h2 className="page-title"><Icon name="book" size={22} /> {t('wordsLearned')}</h2>
      <p className="lw-total">{totalCount} words learned in total</p>

      {totalCount === 0 ? (
        <div className="lw-empty">
          <span className="lw-empty-icon"><Icon name="bulb" size={48} color="var(--text-muted)" /></span>
          <p className="lw-empty-title">No words learned yet</p>
          <p className="lw-empty-text">Start learning with flashcards and your progress will appear here!</p>
        </div>
      ) : (
        <div className="lw-sections">
          {Object.entries(grouped).map(([section, words]) => (
            <div key={section} className="lw-section">
              <div className="lw-section-header">
                <span className="lw-section-name">{section}</span>
                <span className="lw-section-count">{words.length} words</span>
              </div>
              <div className="lw-words">
                {words.map((word) => (
                  <div key={word.key} className="lw-word-row">
                    <span className="lw-word-fi">{word.question}</span>
                    <span className="lw-word-en">{getAns(word)}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LearnedWordsScreen;
